import { FC, useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import { Drawer, DrawerAnchor, IconButton, useDrawer } from '@lambdacurry/component-library';

export interface BottomToRightDrawerProps {
  className?: string;
  name: string;
}

export const BottomToRightDrawer: FC<BottomToRightDrawerProps> = ({ children, className, name }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const options: { anchor?: DrawerAnchor; width?: number } = {
    anchor: isDesktop ? 'right' : 'bottom',
    width: isDesktop ? 496 : windowWidth
  };

  const {
    drawerActions: { toggleDrawer }
  } = useDrawer();

  useEffect(() => window.addEventListener('resize', () => setWindowWidth(window.innerWidth)), []);

  return (
    <Drawer className={classNames(`bottom-to-right-drawer`, className)} name={name} options={options}>
      <IconButton className="ml-[-8px]" icon="close" onClick={() => toggleDrawer({ name })} />

      {children}
    </Drawer>
  );
};
